/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Preset_MonthInputs */

const vi_warehouse_sales_preset_month = /** @type {(inputs: Warehouse_Sales_Preset_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tháng này`)
};

/**

* @param {Warehouse_Sales_Preset_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_preset_month = /** @type {((inputs?: Warehouse_Sales_Preset_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Preset_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_preset_month(inputs)
});